import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { objectUtils } from '@codametrix/ui-common';
import classnames from 'classnames';
const DEFAULT_PROPS = {
    documentMetadata: [],
    onSelect: (docMetadata)=>{}
};
const DocCategories = {
    DFT: 'DFTs',
    DFT_IN: 'Inbound DFTs',
    DFT_OUT: 'Outbound DFTs',
    NTE: 'Notes',
    NOTE: 'Notes',
    HL7: 'HL7 Messages',
    DFT_EHR: 'DFT EHRs'
};
const NotesSidebar = (passed)=>{
    const props = {
        ...DEFAULT_PROPS,
        ...passed
    };
    const { documentMetadata, onSelect, activeNote } = props;
    //@ts-ignore
    const prepped = (documentMetadata || []).map((doc)=>{
        // Document categories are not named for end users.
        // Supplant with our own category names, shown above.
        // But if someone adds a document category we don't want to
        // blow up.
        return {
            ...doc,
            documentCategory: DocCategories[doc.documentCategory] || doc.documentCategory
        };
    });
    const docGroups = objectUtils.groupBy(prepped, 'documentCategory');
    const sortDocs = (a, b)=>{
        if (a === b) return 0;
        if (a === 'HL7 Messages' || a === 'Notes') return -1;
        if (b === 'HL7 Messages' || b === 'Notes') return 1;
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
    };
    const groups = Object.keys(docGroups).sort(sortDocs).map((key)=>{
        const docs = objectUtils.get(docGroups, key) ?? [];
        const items = docs.map((document, idx)=>{
            const onClick = (event)=>{
                event.preventDefault();
                onSelect(document);
            };
            const isActive = activeNote.id === document.id;
            const styleClasses = classnames([
                {
                    'is-active': isActive
                },
                'sidebar-link'
            ]);
            return /*#__PURE__*/ _jsx("li", {
                className: styleClasses,
                children: /*#__PURE__*/ _jsxs("a", {
                    "data-testid": "listlink",
                    href: "#/something",
                    onClick: onClick,
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "document-name",
                            "data-testid": "document-name",
                            children: document.documentName ?? 'Name N/A'
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "document-description",
                            children: document.documentDescription
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "document-status",
                            children: document.documentStatus
                        })
                    ]
                })
            }, document.documentGuid.uuid);
        });
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx("span", {
                    className: "note-doc-category",
                    "data-testid": "note-doc-category",
                    children: docs[0].documentCategory
                }),
                /*#__PURE__*/ _jsx("ul", {
                    className: "note-sidebar-list",
                    children: items
                })
            ]
        }, key);
    });
    return /*#__PURE__*/ _jsx("div", {
        className: "notes-sidebar",
        "data-testid": "notes-sidebar",
        children: /*#__PURE__*/ _jsx("div", {
            className: "sidebar-fixed",
            children: /*#__PURE__*/ _jsx("div", {
                className: "sidebar-container",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "sidebar-inner",
                    children: groups
                })
            })
        })
    });
};
export { NotesSidebar };
